import ContactFormBox from '@src/components/sections/educationExpertSection/ContactFormBox';
import SingleInfoCard from '@src/components/sections/educationExpertSection/SingleInfoCard';
import React, { useState } from 'react';
import { Box } from 'theme-ui';

const educationExpertSection = ({ sectionData }: any) => {
  const [selectedButton, setSelectedButton] = useState(2);
  function changeSelectedButton() {
    setSelectedButton(selectedButton === 1 ? 2 : 1);
  }
  return (
    <Box
      sx={{
        position: 'relative',
        padding: ['41px 21px 107px 21px', '41px 32px 107px 32px'],
        maxWidth: '1315px',
        margin: 'auto',
      }}
    >
      <Box>
        <Box
          sx={{
            lineHeight: 1.2,
            margin: 'auto',
            fontSize: ['28px', '54px'],
            maxWidth: '1013px',
            textAlign: 'center',
          }}
        >
          {sectionData?.title}
        </Box>
        <Box
          sx={{
            textAlign: 'center',
            margin: ['31px 0 10px 0', '43px 0 10px 0'],
            fontSize: ['19px', '32px'],
            color: selectedButton === 1 ? '' : 'primary',
            cursor: selectedButton === 1 ? '' : 'pointer',
          }}
          onClick={() => setSelectedButton(1)}
        >
          {' '}
          {sectionData?.firstButton}{' '}
        </Box>
        <Box
          sx={{
            textAlign: 'center',
            margin: 0,
            fontSize: ['19px', '32px'],
            color: selectedButton === 2 ? '' : 'primary',
            cursor: selectedButton === 2 ? '' : 'pointer',
          }}
          onClick={() => setSelectedButton(2)}
        >
          {' '}
          {sectionData?.secondButton}{' '}
        </Box>
      </Box>
      <Box
        sx={{
          padding: ['52px 0', '79px 0 49px 0'],
          margin: 'auto',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {selectedButton === 1 &&
          sectionData.firstFeatures.length &&
          sectionData.firstFeatures.map((item: any, index: number) => (
            <SingleInfoCard
              key={index}
              index={index}
              item={item}
              selectedButton={selectedButton}
            />
          ))}
        {selectedButton === 2 &&
          sectionData.secondFeatures.length &&
          sectionData.secondFeatures.map((item: any, index: number) => (
            <SingleInfoCard
              key={index}
              index={index}
              item={item}
              selectedButton={selectedButton}
            />
          ))}
        <Box
          sx={{
            color: 'primary',
            cursor: 'pointer',
            textAlign: 'center',
            fontSize: '20px',
          }}
          onClick={changeSelectedButton}
        >
          {selectedButton === 1
            ? sectionData.secondButton
            : sectionData.firstButton}
        </Box>
      </Box>
      <ContactFormBox contactFormData={sectionData.contactForm} />
    </Box>
  );
};

export default educationExpertSection;
